import { useEffect, useState } from 'react';
import { useCalendar } from '@/state/calendar';
import { useSurfaces } from '@/state/surfaces';
import { cn } from '@/lib/cn';

export function NextEventBadge() {
  const events = useCalendar((s) => s.events);
  const open = useSurfaces((s) => s.open);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 30_000);
    return () => clearInterval(id);
  }, []);

  const next = events
    .filter((e) => e.startTimeMs > now)
    .sort((a, b) => a.startTimeMs - b.startTimeMs)[0];

  if (!next) return null;

  const remainingMs = next.startTimeMs - now;
  const min = Math.floor(remainingMs / 60_000);
  const hour = Math.floor(min / 60);
  const day = Math.floor(hour / 24);
  let label: string;
  if (day >= 1) label = `${day}d`;
  else if (hour >= 1) label = `${hour}h ${min % 60}m`;
  else label = `${min}m`;

  const imminent = remainingMs < 30 * 60_000;

  return (
    <button
      onClick={() => open('calendar')}
      className={cn(
        'hidden items-center gap-1.5 rounded border px-2 py-0.5 text-mono-xs transition-colors sm:flex',
        imminent
          ? 'border-[var(--critical)] text-[var(--critical)] animate-pulse'
          : 'border-[var(--border-subtle)] text-[var(--text-muted)] hover:bg-[var(--bg-elevated)]',
      )}
      title={next.description}
    >
      <span className="opacity-70">next:</span>
      <span className="font-bold text-[var(--text-primary)] truncate max-w-[180px]">{next.title}</span>
      <span className="tabular-nums">in {label}</span>
    </button>
  );
}
